export default "/_next/static/images/carousel-arrow-f4d5461a51a8d55c4bb19501d7db760a.svg";